export default __webpack_public_path__ + "static/media/CinzelDecorative-Bold.1e5b9a99.ttf";